const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

const appList = r =>
  require.ensure(
    [],
    () => r(require('@/modules/developer/appList.vue')),
    'developer'
  )

const appSetting = r =>
  require.ensure(
    [],
    () => r(require('@/modules/developer/appSetting.vue')),
    'developer'
  )
const appRecycle = r => {
  require.ensure(
    [],
    () => r(require('@/modules/developer/appRecycle.vue')),
    'developer'
  )
}

const configType = r => {
  require.ensure(
    [],
    () => r(require('@/modules/developer/configType.vue')),
    'developer'
  )
}
const configSetting = r => {
  require.ensure(
    [],
    () => r(require('@/modules/developer/appConfigSetting.vue')),
    'developer'
  )
}
const appFunSetting = r => {
  require.ensure(
    [],
    () => r(require('@/modules/developer/appSetting/appFunSetting.vue')),
    'developer'
  )
}

const developer = [
  {
    path: '/appManager',
    name: 'appManager',
    component: Layout,
    hidden: false,
    meta: {
      id: 'e47c982d4fc943d09ecc0baf78e70a0b',
      auth: true
    },
    redirect: '/appManager/appList',
    children: [
      {
        path: '/appManager/appList',
        name: 'appList',
        component: appList,
        meta: {
          breadcrumbShow: true,
          id: '4119c1c6f0644e79badb1585135d3180',
          auth: true
        }
      },
      {
        path: '/appManager/configSetting',
        name: 'configSetting',
        component: configSetting,
        meta: {
          breadcrumbShow: true,
          id: 'bece0e007ed24f02b62a68723c5489f2',
          auth: true
        }
      },
      {
        path: '/appManager/appRecycle',
        name: 'appRecycle',
        component: appRecycle,
        meta: {
          breadcrumbShow: true,
          id: '75069cffbfd140f9bef1c4391e10e324',
          auth: true
        }
      },
      {
        path: '/appManager/configType',
        name: 'configType',
        component: configType,
        meta: {
          breadcrumbShow: true,
          id: '7b8a52d751334ac6a77630900272dbde',
          auth: true
        }
      },
      {
        path: '/appSetting/appSetting',
        name: 'appSetting2',
        component: appSetting,
        hidden: true,
        meta: {
          id: '3afb89e1cf98476ea8cf57637c4840c4',
          auth: true,
          showApp: true
        }
      },
      {
        path: '/appManager/appFunSetting',
        name: 'appFunSetting',
        component: appFunSetting,
        hidden: true,
        meta: {
          id: 'eba6c6f95bb74713853363d89fa004fa',
          auth: true,
          showApp: true
        }
      }
    ]
  }
]

export default developer



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/developer.js